import React from "react";
import { useSignalRConnectionStatus } from "../../../hooks/useSignalRConnectionStatus";
import { SIGNALR_STATUS } from "../../../types/signalRConnection.types";
import "./SignalRConnectionPill.css";

const STATUS_CONFIG = {
  [SIGNALR_STATUS.CONNECTED]: {
    label: "Live",
    title: "Connected to real-time notifications",
    className: "signalr-pill--connected",
  },
  [SIGNALR_STATUS.CONNECTING]: {
    label: "Connecting",
    title: "Connecting to notification service…",
    className: "signalr-pill--pending",
  },
  [SIGNALR_STATUS.RECONNECTING]: {
    label: "Reconnecting",
    title: "Reconnecting to notification service…",
    className: "signalr-pill--pending",
  },
  [SIGNALR_STATUS.DISCONNECTED]: {
    label: "Offline",
    title: "Not connected to real-time notifications",
    className: "signalr-pill--offline",
  },
  [SIGNALR_STATUS.ERROR]: {
    label: "Error",
    title: "Could not connect to notification service",
    className: "signalr-pill--error",
  },
  [SIGNALR_STATUS.IDLE]: {
    label: "Inactive",
    title: "Real-time notifications inactive",
    className: "signalr-pill--idle",
  },
};

const SignalRConnectionPill = ({ className = "", compact = false }) => {
  const { status, showStatus } = useSignalRConnectionStatus();

  if (!showStatus) {
    return null;
  }

  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG[SIGNALR_STATUS.IDLE];

  return (
    <span
      className={`signalr-pill ${config.className} ${
        compact ? "signalr-pill--compact" : ""
      } ${className}`.trim()}
      title={config.title}
      role="status"
      aria-live="polite"
    >
      <span className="signalr-pill-dot" aria-hidden="true" />
      <span className="signalr-pill-label">{config.label}</span>
    </span>
  );
};

export default SignalRConnectionPill;
